import React from "react";
import Badge from "@mui/material/Badge";

export const withNewBadge = (WrapComp) => (props) =>
  (
    <Badge badgeContent={`New`} color="secondary">
      <WrapComp {...props} />
    </Badge>
  );
